<template>
  <BlokkliProvider v-bind="blokkliProps">
    <BlokkliField
      name="field_paragraphs"
      :list="paragraphs"
      :allowed-fragments="['anchor_nav']"
    />
    <slot />
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import type { GroupB2bFragment } from '#graphql-operations'

defineProps<{
  title?: string
  nid?: string
  uuid: string
  canEdit?: boolean
  subtitle?: string
  body?: string
  paragraphs?: GroupB2bFragment['paragraphs']
  blokkliProps: GroupB2bFragment['blokkliProps']
}>()
</script>
